import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M14.5 13c-.544 0-1.044.178-1.454.474l-.044-.029L6.279 9l6.722-4.444.044-.029A2.492 2.492 0 0 0 17 2.5a2.5 2.5 0 1 0-5 0c0 .103.018.201.03.301l-.131.087-6.61 4.37A2.491 2.491 0 0 0 3.5 6.5a2.5 2.5 0 1 0 1.789 4.242l6.61 4.37.131.086c-.012.101-.03.199-.03.302a2.5 2.5 0 1 0 2.5-2.5z" />
  </svg>
);

export default SvgComponent;
